import * as yup from 'yup';

export type ConnectionType = 'snowflake' | 'oauth';

export interface AllVueFormValues {
  connectionType: ConnectionType;
  database: string;
  clientId: string;
  clientSecret: string;
  tokenEndpoint: string;
}

export function allVueConfigSchema(isExistingOAuthConfig: boolean) {
  return yup.object({
    connectionType: yup
      .string()
      .oneOf(['snowflake', 'oauth'] as const)
      .required(),
    database: yup.string().when('connectionType', {
      is: 'snowflake',
      then: (schema) => schema.trim().required('Database name is required'),
      otherwise: (schema) => schema.default(''),
    }),
    clientId: yup.string().when('connectionType', {
      is: 'oauth',
      then: (schema) => schema.trim().required('Client ID is required'),
      otherwise: (schema) => schema.default(''),
    }),
    clientSecret: yup.string().when('connectionType', {
      is: 'oauth',
      then: (schema) =>
        isExistingOAuthConfig ? schema.default('') : schema.trim().required('Client Secret is required'),
      otherwise: (schema) => schema.default(''),
    }),
    tokenEndpoint: yup.string().when('connectionType', {
      is: 'oauth',
      then: (schema) =>
        schema.url('Please provide a valid URL').trim().required('Token Endpoint is required'),
      otherwise: (schema) => schema.default(''),
    }),
  });
}

export function getDefaultAllVueConfig(): AllVueFormValues {
  return {
    connectionType: 'snowflake',
    database: '',
    clientId: '',
    clientSecret: '',
    tokenEndpoint: '',
  };
}
